import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { HseTermKey } from '../constants/hseTerms';
import type { SaveHseWeeklyReportRequest } from '../types/hse-weekly-report.type';

const hseWeeklyUrl = (organizationId: string, siteId: string) =>
  `/dashboard/organization/${organizationId}/collection_site/${siteId}/hse-weekly`;

export const getHseWeeklyReport = (organizationId: string, siteId: string, weekStart: string) =>
  makeRequest({
    url: hseWeeklyUrl(organizationId, siteId),
    method: HttpMethods.GET,
    params: { week_start: weekStart },
  });

export const saveHseWeeklyReport = (
  organizationId: string,
  siteId: string,
  weekStart: string,
  body: SaveHseWeeklyReportRequest,
) =>
  makeRequest({
    url: hseWeeklyUrl(organizationId, siteId),
    method: HttpMethods.PATCH,
    params: { week_start: weekStart },
    data: body,
  });

export const submitHseWeeklyReport = (organizationId: string, siteId: string, weekStart: string) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/submit`,
    method: HttpMethods.POST,
    params: { week_start: weekStart },
  });

export const reopenHseWeeklyReport = (
  organizationId: string,
  siteId: string,
  weekStart: string,
  reason: string,
) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/reopen`,
    method: HttpMethods.POST,
    params: { week_start: weekStart },
    data: { reason },
  });

export const getHseWeeklyHistory = (organizationId: string, siteId: string, weekStart: string) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/history`,
    method: HttpMethods.GET,
    params: { week_start: weekStart },
  });

export const listHseWeeks = (organizationId: string, siteId: string) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/weeks`,
    method: HttpMethods.GET,
  });

export const listHseEvidence = (organizationId: string, siteId: string, weekStart: string) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/evidence`,
    method: HttpMethods.GET,
    params: { week_start: weekStart },
  });

export const addHseEvidence = (
  organizationId: string,
  siteId: string,
  weekStart: string,
  files: { asset_id: string; term_key: HseTermKey | null }[],
) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/evidence`,
    method: HttpMethods.POST,
    params: { week_start: weekStart },
    data: { files },
  });

export const removeHseEvidence = (organizationId: string, siteId: string, evidenceId: string) =>
  makeRequest({
    url: `${hseWeeklyUrl(organizationId, siteId)}/evidence/${evidenceId}`,
    method: HttpMethods.DELETE,
  });
